import { apiPaths } from "@/lib/api/paths";
import type { CreateReleaseDTO, CreateReleaseResponse } from "./type";
import { apiClient } from "@/lib/api/client";

export async function createRelease(
  release: CreateReleaseDTO,
): Promise<CreateReleaseResponse> {
  const response = await apiClient.post<CreateReleaseResponse>(
    apiPaths.releases.create,
    release,
  );
  return response.data;
}
